import React from 'react';
import { outcomes } from '../data/bonuses';
export function OutcomesSection() {
  return <section className="bg-brand-cream px-4 py-7" data-id="element-121" data-mp="1bdptldkfvhjr">
      <div className="mx-auto max-w-2xl" data-id="element-122" data-mp="1bcxy02qudjth">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-123" data-mp="16ewh9ogw1wl6">
          Cosa cambierà da oggi
        </h2>

        <div className="mt-4 space-y-3" data-id="element-124" data-mp="12fxcq4z2k1u9">
          {outcomes.map(outcome => <article key={outcome.title} className="rounded-r-lg border-l-4 border-brand-green bg-white p-4 shadow-sm" data-id="element-125" data-mp="1z31y404tn1fq">
              <h3 className="font-display text-[15px] font-extrabold uppercase leading-tight text-brand-navy sm:text-base" data-id="element-126" data-mp="1pd8o33kbuudl">
                <span aria-hidden="true" data-id="element-127" data-mp="1lbx7fnjfljhj">{outcome.emoji}</span> {outcome.title}
              </h3>

              {outcome.lines.length > 0 && <div className="mt-2 space-y-1 text-sm font-medium leading-snug text-brand-graphite" data-id="element-128" data-mp="2d3mgiv6tqv8p">
                  {outcome.lines.map(line => <p key={line} data-id="element-129" data-mp="ovv5sf1oaoyg">{line}</p>)}
                </div>}

              {outcome.chips && <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-130" data-mp="f5jrpzo9yzdu">
                  {outcome.chips.map(chip => <li key={chip} className="rounded border border-brand-green/30 bg-brand-green/10 px-2 py-1 text-[12px] font-semibold leading-tight text-brand-navy" data-id="element-131" data-mp="k4d6rwj7myg4">
                      {chip}
                    </li>)}
                </ul>}

              {outcome.closing && <div className="mt-2 space-y-1 text-sm font-medium leading-snug text-brand-graphite" data-id="element-132" data-mp="3seg0mjbnde9i">
                  {outcome.closing.map(line => <p key={line} data-id="element-133" data-mp="1qm0aa1v4lw4x">{line}</p>)}
                </div>}
            </article>)}
        </div>
      </div>
    </section>;
}